<div class="">
  <div class="common-right-sec-bg">
    @if (!loading) {
      <div class="payment-success-container">
        <div class="success-card">
          <div class="success-icon">
            <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="40" cy="40" r="40" fill="currentColor"/>
              <path d="M25 40L35 50L55 30" stroke="white" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 class="success-title">Success</h2>
          <p class="success-message">Redirecting you to billing management...</p>
          @if (paymentDetails.sessionId) {
            <div class="payment-details">
              <div class="detail-row">
                <span class="detail-label">Session:</span>
                <span class="detail-value">{{ paymentDetails.sessionId }}</span>
              </div>
            </div>
          }
          <ng-template #loading>
            <div class="loading-container">
              <div class="loading-spinner">
                <div class="spinner"></div>
                <p>Processing payment...</p>
              </div>
            </div>
          </ng-template>
          <div class="action-buttons">
            <button class="btn btn-theme" (click)="goToSubscription()">
              Back to subscription
            </button>
          </div>
        </div>
      </div>
    }

    @if (loading) {
      <div class="loading-container">
        <div class="loading-spinner">
          <div class="spinner"></div>
          <p>Processing payment...</p>
        </div>
      </div>
    }
  </div>
</div>
